import { Fragment } from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useRef } from 'react';
import { getStockFundFixed, getStockRightFundList, stockRightList } from "../tools/market/functions"

export default function MarketSingleTable({ config, rows, filterBy, single, isFilter, date, onFilter, theme }) {
    const tableRef = useRef(null);

    const tableHeader = config.map((column) => {
        if (column.header) {
            return <Fragment key={column.key}>{column.header()}</Fragment>;
        }

        return <th className='text-center' key={column.key}>{column.value}</th>;
    });

    const rendererFunction = (row, column) => {
        let value, className;
        value = column.renderer && column.renderer(row, filterBy)
        className = column.classes && column.classes(row, filterBy)
        return [value, className]
    }

    const handleClick = (e) => {
        const selecetedRow = document.querySelector('tr.selected')
        selecetedRow && selecetedRow.classList.remove('selected')
        e.target.parentNode.classList.add('selected')
    }

    const renderedRows = rows.map((row, index) => {
        const renderedCells = config.map((column) => {
            const [value, className] = rendererFunction(rows[index], column)
            // const classNames = index % 2 === 0 ? 'bg-secondary px-2 ' + className: 'bg-white px-2 ' + className
            const classNames = 'px-2 '
            return (
                <td className={classNames} key={column.key} style={{ direction: 'ltr' }}>
                    <span className={`d-inline-flex px-2 py-1 fw-semibold bg-opacity-10  ${className}`}>
                        {value}
                    </span>
                </td>
            );
        });

        const tr = <tr onClick={handleClick} className="text-center" key={`${row.tse_url}${row.date}`}>
            <td>{index + 1}</td>
            {renderedCells}
        </tr>

        if (single) {
            if (row.l18 && (!(row.l18).includes('2') && !(row.l18).includes('3') && !(row.l18).includes('4') && !(row.l18).includes('5'))) {
                if (filterBy === 'stock_rights') {
                    if (stockRightList.includes(row.stock)) {
                        return tr
                    }
                } else if (filterBy === 'stock_rights_fund') {
                    if (getStockRightFundList(row)) {
                        return tr
                    }
                } else if (filterBy === 'fund_fixed') {
                    if (getStockFundFixed(row)) {
                        return tr
                    }
                }
            }

        } else {
            return tr
        }
        return ''
    });


    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'market',
        sheet: 'signal'
    })

    const btnClass = isFilter ? 'btn-primary text-white' : 'btn-secondary text-dark'

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <button onClick={onDownload} className='btn bg-success text-white mb-2 p-3'> خروجی اکسل </button>
                {onFilter &&
                    <>
                        <button onClick={onFilter} className={`btn ${btnClass} mb-2 p-3`}>فیلتر</button>
                    </>
                }
                {
                    filterBy === 'stock_rights'
                        ? <h3>سهام و حق تقدم</h3>
                        : filterBy === 'stock_rights_fund'
                            ? <h3>سهام و حق تقدم و صندوق سهامی</h3>
                            :
                            filterBy === 'fund_fixed'
                                ? <h3>صندوق در آمد ثابت</h3>
                                : ''
                }
                {date && <h2>{date}</h2>}
            </div>
            {/* <div className='table-responsive'> */}

            <table className={`table ${theme} table-rounded`} ref={tableRef}>
                <thead>
                    <tr className="fw-semibold fs-6 border-bottom-2 mb-5 border-gray-200">
                        <th className='text-center'>ردیف</th>
                        {tableHeader}
                    </tr>
                </thead>

                <tbody>

                    {renderedRows}
                </tbody>
            </table>
            {/* </div> */}
        </>
    )
}